import React, { useState, useEffect } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faSync } from "@fortawesome/free-solid-svg-icons";
import ProcessedFailedPending from "./ProcessedFailedPending";
import { getChainIdLS } from "../../../utils/utils";
import { callAPI } from "../../../axios";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

export default function APKInstallationDetails() {
  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
      className: `eachtab ${value === index ? "Mui-selected" : ""}`,
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  // const params = useParams();
  const [localLoader, setLocalLoader] = useState(true);
  const [reportData, setReportData] = useState({});
  const [originalAllList, setOriginalAllList] = useState([]);
  const [allList, setAllList] = useState([]);
  const [originalProcessedList, setOriginalProcessedList] = useState([]);
  const [processedList, setProcessedList] = useState([]);
  const [originalFailedList, setOriginalFailedList] = useState([]);
  const [failedList, setFailedList] = useState([]);

  const [originalAPKTriggerList, setOriginalAPKTriggerList] = useState([]);
  const [aPKTriggerList, setAPKTriggerList] = useState([]);
  
 const [originalNotReadyForAPkTriggerList, setOriginalNotReadyForAPkTriggerList] = useState([]);
  const [notReadyForAPkTriggerList, setNotReadyForAPkTriggerList] = useState([]);

  const [search, setSearch] = useState("");

  const [value, setValue] = useState(0);

  const { chainId } = useSelector((state) => state.chainIdReducer);
  const { viewType } = useSelector((state) => state.viewTypeReducer);

  useEffect(() => {
    listReport();
    setAllList([]);
    setAPKTriggerList([]);
    setProcessedList([]);
    setFailedList([]);
    setNotReadyForAPkTriggerList([]);
    setValue(0);
    setSearch("");
  }, [chainId]);

  const listReport = () => {
    const apiPath = `/auto-mode/report`;
    callAPI(apiPath, "GET", {}, { chainId: getChainIdLS() })
      .then((response) => {
        setReportData(response);
        setOriginalAllList(response?.result);
        setAllList(response?.result)
        if (response?.result?.length) {
          const processedFilterData = response?.result?.filter((data) => data?.apkInstalled)
          setOriginalProcessedList(processedFilterData)
          setProcessedList(processedFilterData)
          const failedFilterData = response?.result?.filter((data) => !data?.apkInstalled && data?.apkTriggered)
          setOriginalFailedList(failedFilterData);
          setFailedList(failedFilterData)
          const readyForAPKTrigger = response?.result?.filter((data) => data?.readyForApkTrigger && !data?.apkTriggered)
          setOriginalAPKTriggerList(readyForAPKTrigger)
          setAPKTriggerList(readyForAPKTrigger)

          const notReadyForAPKTrigger = response?.result?.filter((data) => !data?.readyForApkTrigger)
          setOriginalNotReadyForAPkTriggerList(notReadyForAPKTrigger);
          setNotReadyForAPkTriggerList(notReadyForAPKTrigger);

        }
        setLocalLoader(false);
      })
      .catch((err) => {
        console.warn(err.message);
        setLocalLoader(false);
      });
  }

  const hotelExcelDownload = () => {
    setLocalLoader(true);
    const headers = Object.keys(originalAllList[0]).join(",");
    const rows = originalAllList
      .map((obj) =>
        Object.values(obj)
          .map((value) => `"${String(value).replace(/"/g, '""')}"`)
          .join(",")
      )
      .join("\n");

    const csvContent = headers + "\n" + rows;

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "CDSN_Report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    setLocalLoader(false);
  };

  const onSearchChangeHandler = (e) => {
    setSearch(e.target.value);
    const allfilterData = originalAllList?.filter((item) => item?.cdsn11?.includes(e.target.value.toString()) || item?.cdsn10?.includes(e.target.value.toString()));
    setAllList(allfilterData);

    const processedfilterData = originalProcessedList?.filter((item) => item?.cdsn11?.includes(e.target.value.toString()) || item?.cdsn10?.includes(e.target.value.toString()));
    setProcessedList(processedfilterData);

    const failedfilterData = originalFailedList?.filter((item) => item?.cdsn11?.includes(e.target.value.toString()) || item?.cdsn10?.includes(e.target.value.toString()));
    setFailedList(failedfilterData);

    const aPKTriggerfilterData = originalAPKTriggerList?.filter((item) => item?.cdsn11?.includes(e.target.value.toString()) || item?.cdsn10?.includes(e.target.value.toString()));
    setAPKTriggerList(aPKTriggerfilterData);

     const NotReadyApkTriggerfilterData = originalNotReadyForAPkTriggerList?.filter((item) => item?.cdsn11?.includes(e.target.value.toString()) || item?.cdsn10?.includes(e.target.value.toString()));
    setNotReadyForAPkTriggerList(NotReadyApkTriggerfilterData);
  };

  return (
    <div className="row config-hotel apk-installation-details">
      <div className="col-12 left-column">
        {localLoader && (
          <div className="circular-progress">
            <CircularProgress />
          </div>
        )}
        <div className="bg-white">
          <div className="left-column-header mb-0 p-2">
            <p>Auto Mode Report</p>
          </div>
        </div>
        <div className="view-header mt-0">
          <div>
            <span>Hotel Type : </span>{" "}
            {reportData?.viewType === null ? "NA" : reportData?.viewType === "hotelApp" ? "IHCL" : "HMS"}
          </div>
          <div>
            <span>Chain ID: </span>{" "}
            {reportData?.result?.length ? reportData?.result[0]?.enterpriseChainId : "NA"}
          </div>
          <div>
            <span>Last Update Time: </span>{" "}
            {reportData?.lastUpdatedAt ? dayjs(reportData?.lastUpdatedAt).format("DD MMM YYYY | HH:mm:ss") : "NA"}
          </div>
          <div className="d-flex">
            <div className="search-input">
              <FontAwesomeIcon icon={faSearch} className="icon-magnifier" />
              <input
                type="text"
                name="input-search"
                className="form-control"
                placeholder="Search CDSN"
                onChange={(e) => onSearchChangeHandler(e)}
                value={search}
                onKeyPress={(e) => {
                  e.key === "Enter" && e.preventDefault();
                }}
              />
            </div>

            <button
              onClick={hotelExcelDownload}
              type="button"
              className={`ms-3 published`}
            >
              Download CSV
            </button>
          </div>
        </div>
        {/* <div className="view-header mt-0">
          <div>
            <span>Total CDSN Count : </span> {reportData?.totalCdsnCount}
          </div>
          <div>
            <span>Ready For APK Trigger : </span> {reportData?.readyForApkCount}
          </div>
          <div>
            <span>APK Pushed On Boxes : </span> {parseInt(reportData?.apkInstalledCount) + parseInt(reportData?.apkInstallFailedCount)}
          </div>
          <div>
            <span>APK Installation Success : </span>{" "}
            {reportData?.apkInstalledCount}
          </div>
          <div>
            <span>APK Pushed but Installation Pending : </span>{" "}
            {reportData?.apkInstallFailedCount}
          </div>
        </div> */}

        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          className="apk-details-table"
          TabIndicatorProps={{
            hidden: true,
            style: { transition: "none" },
          }}
        >
          <Tab label={`All CDSNs (${reportData?.totalCdsnCount})`} {...a11yProps(0)} />
          <Tab label={`${viewType==='custom'?'Not Linked with Hotel':'Not Ready for APK Trigger'} (${notReadyForAPkTriggerList?.length})`} {...a11yProps(1)} />
          <Tab label={`${viewType==='custom'?`Linked with hotel but not Linked with Room (${allList?.filter((data)=>data?.roomNumber=== null && data?.readyForApkTrigger===true)?.length})`:`APK Pushed But Installation Pending (${failedList?.length})`}`} {...a11yProps(2)} />
          <Tab label={`${viewType==='custom'?'Linked With Hotel':'Ready for APK Trigger'}  (${aPKTriggerList?.length})`}  {...a11yProps(3)} />
          <Tab label={`${viewType==='custom'?`Linked with Room (${allList?.filter((data)=>data?.roomNumber)?.length}`: `APK Installed (${processedList?.length}` })`} {...a11yProps(4)} />
          {viewType==='hotelApp' && <Tab label={`APK Version Mismatch (${allList?.filter((data)=>data?.apkVersionMismatch)?.length})` } {...a11yProps(5)} />}
        </Tabs>
        <TabPanel value={value} index={0}>
          <ProcessedFailedPending
            // isFailed={false}
            listReport={listReport}
            list={allList}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          
          <ProcessedFailedPending
            // isFailed={true}
            list={notReadyForAPkTriggerList}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          
          <ProcessedFailedPending
            // isFailed={true}
            list={viewType==='custom'?allList?.filter((data)=>data?.roomNumber=== null && data?.readyForApkTrigger===true):failedList}
          />
        </TabPanel>
        <TabPanel value={value} index={3}>
  
          <ProcessedFailedPending
            // isFailed={false}
            listReport={listReport}
            list={aPKTriggerList}
          />
        </TabPanel>
        <TabPanel value={value} index={4}>
        
          <ProcessedFailedPending
            // isFailed={false}
            listReport={listReport}
            list={viewType==='custom'?allList?.filter((data)=>data?.roomNumber):processedList}
          />
        </TabPanel>
        {viewType==='hotelApp' && <TabPanel value={value} index={5}>
  
          <ProcessedFailedPending
            // isFailed={false}
            listReport={listReport}
            list={allList?.filter((data)=>data?.apkVersionMismatch)}
          />
        </TabPanel>}
      </div>
    </div>
  );
}
